module.exports = __webpack_public_path__ + "img/jcc-promise-logo.a89a6713.jpg";